module.exports = __webpack_public_path__ + "static/media/mx.e54f7846.svg";